// Global store for functions that need to be accessed across components
const globalStore = {
  createVideoSprite: null,
  createAudioSprite: null,
  createImageSprite: null,
  createGifSprite: null,
  createAiSprite: null,
};

export const setGlobalCreateVideoSprite = (fn) => {
  globalStore.createVideoSprite = fn;
};

export const setGlobalCreateAudioSprite = (fn) => {
  globalStore.createAudioSprite = fn;
};

export const setGlobalCreateImageSprite = (fn) => {
  globalStore.createImageSprite = fn;
};

export const setGlobalCreateGifSprite = (fn) => {
  globalStore.createGifSprite = fn;
};

export const getGlobalCreateAudioSprite = () => {
  return globalStore.createAudioSprite;
};

export const getGlobalCreateImageSprite = () => {
  return globalStore.createImageSprite;
};

export const getGlobalCreateVideoSprite = () => {
  return globalStore.createVideoSprite;
};

export const getGlobalCreateGifSprite = () => {
  return globalStore.createGifSprite;
};

export const setGlobalCreateAiSprite = (fn) => {
  globalStore.createAiSprite = fn;
};

export const getGlobalCreateAiSprite = () => {
  return globalStore.createAiSprite;
};

export default globalStore;